import { getAsyncStatusFromRtkQueryStates } from 'lib-shared-auth';
import { useEffect } from 'react';

import { waitMusicApi } from 'apis/waitMusic';
import { useAppPathParams } from 'utils/url/useAppPathParams';

import { FileUsagePage } from '../../components/fileUsagePage/fileUsagePage';

export const SettingsAudioWaitMusic = (): JSX.Element => {
  const { id } = useAppPathParams('/settings/audio/wait-music/:id');
  const [getWaitMusicUsage, { data, ...rtkQueryState }] =
    waitMusicApi.useLazyReadWaitMusicUsageQuery();
  const asyncStatus = getAsyncStatusFromRtkQueryStates(rtkQueryState);

  useEffect(() => {
    getWaitMusicUsage({ id });
  }, [getWaitMusicUsage, id]);

  // Hack to get the wait music name:
  // The wait music usage response doesn't have the name of the music, so find it
  // in the list of all music (the read music response should be cached).
  const { data: musicData } = waitMusicApi.useReadWaitMusicQuery();
  const musicList = musicData?.data.wait_music;
  const waitMusic = musicList?.find((music) => music.id === id);

  const defaultHoldMusic = data?.data.default_hold_music;
  const flowUsage = data?.data.flow_usage || [];

  const usage = defaultHoldMusic
    ? [
        {
          id: 'default',
          name: 'Default hold music',
          active: true,
          updated_at: 'n/a',
        },
        ...flowUsage,
      ]
    : flowUsage;

  return (
    <FileUsagePage
      type="wait-music"
      usage={usage}
      file={waitMusic}
      asyncStatus={asyncStatus}
    />
  );
};
